import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutLanePreferenceTable extends Layout {
    sourcePNNLane: DataSource;
    sourcePnnControl: DataSource;
    tableLanes: Table;
}
